import { z } from "zod/v4";

export const orderlessAuth = {
  name: "orderlessAuth" as const,
  input: z.object(),
  output: z.object({ customerAuthToken: z.string() }),
};
